import { useTranslation } from 'react-i18next';
import { SongType } from 'services/api/entities';
import { SongData } from 'services/store/distribution/types';
import {
  AdvancedOptions,
  ComposerName,
  SongTitle,
  VocalsOptions,
} from './components';
import {
  MetadataContainer,
  BasicMetadataContainer,
  MetadataTitle,
} from './styled';

type PropsType = {
  releaseId: string;
  song: SongData;
};

const SongMetadata = ({ releaseId, song }: PropsType) => {
  const { t } = useTranslation();
  const { songType } = song;

  if (songType === SongType.USER_UPLOADED) {
    return (
      <MetadataContainer>
        <BasicMetadataContainer>
          <MetadataTitle>
            {t('distribution:tracklist:songs:metadata:edit')}
          </MetadataTitle>
          <SongTitle releaseId={releaseId} />
          <ComposerName releaseId={releaseId} />
          <VocalsOptions releaseId={releaseId} />
        </BasicMetadataContainer>
        <AdvancedOptions releaseId={releaseId} />
      </MetadataContainer>
    );
  }

  return (
    <MetadataContainer>
      <BasicMetadataContainer>
        <MetadataTitle>
          {t('distribution:tracklist:songs:metadata:edit')}
        </MetadataTitle>
        <SongTitle releaseId={releaseId} />
      </BasicMetadataContainer>
    </MetadataContainer>
  );
};

export default SongMetadata;
